window.addEventListener('load', function () {
    const container = document.querySelector('.inner-paralax');
    if (!container) return;

    const inner = container.querySelector('.multiblock-inner');
    if (!inner) return;

    const title = inner.firstElementChild;
    const cover = inner.lastElementChild;
    if (!title || !cover || title === cover) return;

    let wrapper = container.closest('.paralax');
    if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        container.parentNode.insertBefore(wrapper, container);
        wrapper.appendChild(container);
    }

    let containerH, coverH, phase1End, enabled;

    function measure() {
        cover.style.transform = '';
        title.style.transform = '';

        containerH = container.offsetHeight; // inkl. padding — används för wrapper.minHeight
        const innerH = inner.offsetHeight;  // exkl. container-padding — används för layoutberäkningar
        coverH = cover.offsetHeight;

        const titleCS  = getComputedStyle(title);
        const titleMT  = parseFloat(titleCS.marginTop);
        const titleMB  = parseFloat(titleCS.marginBottom);
        const titleMBH = title.offsetHeight + titleMT + titleMB;
        const coverMT  = parseFloat(getComputedStyle(cover).marginTop);

        if (titleMBH + coverH > innerH) {
            enabled = false;
            wrapper.style.minHeight = '';
            cover.style.transform   = '';
            return;
        }
        enabled = true;

        // Flex centers the title's full margin box within .multiblock-inner (innerH).
        // Phase 1 ends when the cover's top border reaches the title's bottom margin edge.
        phase1End = (innerH - titleMBH) / 2 - coverMT;

        wrapper.style.minHeight = `${containerH + coverH}px`;
        cover.style.transform   = `translateY(${coverH}px)`;
    }

    function update() {
        if (!enabled) return;

        const scrolled = -wrapper.getBoundingClientRect().top;

        if (scrolled <= 0) {
            cover.style.transform = `translateY(${coverH}px)`;
            title.style.transform = '';
        } else if (scrolled >= coverH) {
            cover.style.transform = 'translateY(0)';
            title.style.transform = `translateY(-${coverH - phase1End}px)`;
        } else if (scrolled <= phase1End) {
            // Fas 1: cover glider upp, titel stannar centrerad
            cover.style.transform = `translateY(${coverH - scrolled}px)`;
            title.style.transform = '';
        } else {
            const phase2 = scrolled - phase1End;
            cover.style.transform = `translateY(${coverH - scrolled}px)`;
            title.style.transform = `translateY(-${phase2}px)`;
        }
    }

    measure();
    update();

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', () => { measure(); update(); }, { passive: true });
});

//# sourceMappingURL=inner-paralax.js.map
